/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { FilterTypeDTO } from "../models";
import { FilterTypeDTOFromJSON, FilterTypeDTOToJSON } from "../models";

/**
 *
 */
export class FilterTypesApi extends runtime.BaseAPI {
  /**
   */
  async findAllRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<FilterTypeDTO>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/filterTypes`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterTypeDTOFromJSON));
  }

  /**
   */
  async findAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterTypeDTO>> {
    const response = await this.findAllRaw(initOverrides);
    return await response.value();
  }
}
